export default "__VITE_ASSET__eD5tiRvY__"